import { createSlice } from '@reduxjs/toolkit';
import axios from 'utils/axios';
// import { dispatch } from 'redux_data/store';


const slice = createSlice({
  name: 'point_of_sales', // This is the name of the slice
  initialState: {
    cart:[],
    selectedProductNonFungible:{},
  },
  reducers: {
    setSelectedProductNonFungible(state, action) { // HAS ERROR
      state.selectedProductNonFungible = action.payload;
    },
    setCart(state, action) { // HAS ERROR
      state.cart = action.payload;
    },
  },
});

export const { 
    setSelectedProductNonFungible , 
    setCart ,
} = slice.actions;

export default slice.reducer;
